export const APK_DOWNLOAD_URL = '/api/app-release/latest.apk';

export function buildCustomSchemeUrl(referralCode) {
  return `cryptofog://ref/${encodeURIComponent(referralCode)}`;
}

export function buildAndroidIntentUrl(referralCode, fallbackUrl) {
  const safeFallbackUrl = fallbackUrl || window.location.href;
  return [
    `intent://ref/${encodeURIComponent(referralCode)}`,
    '#Intent',
    ';scheme=cryptofog',
    ';package=com.example.cryptofogandroid',
    `;S.browser_fallback_url=${encodeURIComponent(safeFallbackUrl)}`,
    ';end',
  ].join('');
}

export function openReferralInApp(referralCode) {
  window.location.href = buildCustomSchemeUrl(referralCode);
}

export function openReferralInChrome(referralCode, fallbackUrl) {
  window.location.href = buildAndroidIntentUrl(referralCode, fallbackUrl);
}

export function startApkDownload() {
  window.location.href = APK_DOWNLOAD_URL;
}
